import React from 'react';
import {
  useSurveyDispatchContext,
  useSurveyContext,
} from '../contexts/SurveyContext';
import { getSurveys } from 'rest/makeSurveyClient';
import { getSearchParam } from 'helpers/router';
import { getErrorMessage } from '@ax2/common/helpers/error';
import { RestError } from '@ax2/common/rest/baseClient';
import { useErrorUpdateContext } from '@ax2/common/contexts/ErrorContext';
import _ from 'lodash';

const RouterWrapper: React.FC = props => {
  // Get survey context initial state (TODO: move it to separate service later)
  const survey = useSurveyContext();
  const surveyDispatch = useSurveyDispatchContext();
  const updateError = useErrorUpdateContext();
  const surveyId = getSearchParam('surveyId');
  React.useEffect(() => {
    if (survey === null && surveyId) {
      // restoring current survey after page reload;
      getSurveys()
        .then(data => {
          const currentSurvey = _.find(data, d => d.id === surveyId);
          if (currentSurvey) {
            surveyDispatch({ type: 'new', survey: currentSurvey });
          }
        })
        .catch(e =>
          updateError({
            text: getErrorMessage(e as RestError),
          })
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <>{props.children}</>;
};

export default RouterWrapper;
